import { useLocation, Link } from 'react-router-dom';
import { FiHome, FiChevronRight } from 'react-icons/fi';

// Comprehensive route map: path → { label, group }
const ROUTE_MAP = {
  '/': { label: 'Dashboard', group: null },
  '/Dashboard': { label: 'Dashboard', group: null },

  // SuperAdmin
  '/AdminPermissions': { label: 'Admin Permissions', group: 'SuperAdmin' },
  '/AngularBuildUpload': { label: 'Angular Build Upload', group: 'SuperAdmin' },
  '/ChannelSetting': { label: 'Channel Setting', group: 'SuperAdmin' },
  '/AssignDid': { label: 'Assign DID', group: 'SuperAdmin' },
  '/AllowPort': { label: 'Allow Port', group: 'Settings' },
  '/Fail2ban': { label: 'Fail2ban', group: 'SuperAdmin' },
  '/NetworkMonitor': { label: 'Network & Internet', group: 'SuperAdmin' },
  '/DncSettings': { label: 'DNC Check', group: 'SuperAdmin' },
  '/PasswordChangeLogs': { label: 'Password Audit Log', group: 'SuperAdmin' },

  // Users
  '/Users': { label: 'Add User', group: 'Users' },
  '/TeamLeaders': { label: 'Permissions', group: 'Users' },

  // Campaign
  '/AddCampaign': { label: 'Add Campaign', group: 'Campaign' },
  '/Makegui': { label: 'Make CRM', group: 'Campaign' },
  '/Editgui': { label: 'Edit CRM', group: 'Campaign' },
  '/Assignlist': { label: 'Assign List', group: 'Campaign' },
  '/Assignagent': { label: 'Assign Agent', group: 'Campaign' },
  '/CampDid': { label: 'Camp DID', group: 'Campaign' },
  '/AddDisposition': { label: 'Disposition', group: 'Campaign' },
  '/ChurnLeads': { label: 'Churn Leads', group: 'Campaign' },
  '/CampaignScript': { label: 'Campaign Script', group: 'Campaign' },

  // Voice-Bot
  '/VoiceBot': { label: 'VoiceBot Campaign', group: 'Voice-Bot' },
  '/VoiceBotIntent': { label: 'VoiceBot Intent', group: 'Voice-Bot' },
  '/VoiceBotCallLogs': { label: 'VoiceBot Call Logs', group: 'Voice-Bot' },
  '/VoiceBotSettings': { label: 'VoiceBot Settings', group: 'Voice-Bot' },

  // Realtime
  '/Realtime': { label: 'Realtime', group: 'Monitor' },

  // Reports
  '/Reportlive': { label: 'Live Report', group: 'Reports' },
  '/Report': { label: 'All Reports', group: 'Reports' },
  '/FilterReport': { label: 'Filter Report', group: 'Reports' },
  '/FilterReportold': { label: 'Filter Report (Old)', group: 'Reports' },
  '/Agentlog': { label: 'Agent Log', group: 'Reports' },
  '/AgentPerformance': { label: 'Agent Performance', group: 'Reports' },
  '/BreakReport': { label: 'Break Report', group: 'Reports' },
  '/Callbackreport': { label: 'Callback Report', group: 'Reports' },
  '/Callbackreportall': { label: 'Callback Report (All)', group: 'Reports' },

  // Settings
  '/UploadAudio': { label: 'Upload Audio', group: 'Settings' },
  '/MusicOnHold': { label: 'Music On Hold', group: 'Campaign' },
  '/UploadNumber': { label: 'Upload Number', group: 'Settings' },
  '/BlockNumber': { label: 'Block Number', group: 'Settings' },
  '/ChangePwd': { label: 'Change Password', group: 'Settings' },
  '/Changepwd': { label: 'Change Password', group: 'Settings' },
  '/AllowIP': { label: 'Allow IP', group: 'Settings' },
  '/Break': { label: 'Break Setting', group: 'Settings' },
  '/TransferNumber': { label: 'Transfer Number', group: 'Settings' },
  '/settings': { label: 'Settings', group: 'Settings' },

  // SMS
  '/Smssuits': { label: 'SMS Suits', group: 'SMS' },
  '/SmsportSetting': { label: 'SMS Port Setting', group: 'SMS' },

  // IVR
  '/AddAgent': { label: 'IVR Agent', group: 'IVR' },
  '/DrawIvr': { label: 'Draw IVR', group: 'IVR' },
  '/IvrTab': { label: 'IVR Tab', group: 'IVR' },
  '/IvrSmsReport': { label: 'IVR SMS Report', group: 'IVR' },
  '/AddIvr': { label: 'Add IVR', group: 'IVR' },
  '/Audio': { label: 'Audio', group: 'IVR' },
  '/Group': { label: 'Group', group: 'IVR' },
  '/Agent': { label: 'Agent', group: 'IVR' },

  // OBD
  '/AddObdCampaign': { label: 'Add OBD Campaign', group: 'OBD' },
  '/ObdRecording': { label: 'OBD Recording', group: 'OBD' },
  '/UploadObdNumber': { label: 'Upload OBD Number', group: 'OBD' },
  '/AddObdAgent': { label: 'OBD Agent', group: 'OBD' },
  '/ObdChannelSetting': { label: 'Channel Setting', group: 'OBD' },
  '/ObdBlockNumber': { label: 'Block Number', group: 'OBD' },
  '/ObdProfile': { label: 'OBD Profile', group: 'OBD' },

  // Agent / User
  '/Crm': { label: 'CRM', group: 'Agent' },
  '/Callback': { label: 'Today\'s Callbacks', group: 'Agent' },
  '/CallBack': { label: 'Today\'s Callbacks', group: 'Agent' },
  '/Callbackactive': { label: 'Active Callbacks', group: 'Agent' },
  '/Callbackall': { label: 'All Callbacks', group: 'Agent' },
  '/CallBackall': { label: 'All Callbacks', group: 'Agent' },
  '/Agentcalllog': { label: 'Call Log', group: 'Agent' },
  '/AgentApr': { label: 'APR Summary', group: 'Agent' },
  '/CallLog': { label: 'Call Log', group: 'Agent' },
  '/IvrReport': { label: 'IVR Report', group: 'IVR' },

  // Misc
  '/Sharescreen': { label: 'Share Screen', group: null },
  '/messages': { label: 'Messages', group: null },
  '/analytics': { label: 'Analytics', group: null },
  '/file-manager': { label: 'File Manager', group: null },
  '/order': { label: 'Order', group: null },
  '/saved': { label: 'Saved', group: null },
};

// /Crm: the agent's working screen gives the header row back to the CRM.
const HIDE_ON = new Set(['/', '/Crm']);

export default function Breadcrumb() {
  const { pathname } = useLocation();

  if (HIDE_ON.has(pathname)) return null;

  const entry = ROUTE_MAP[pathname];
  if (!entry) return null;

  const { label, group } = entry;

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      padding: '7px 18px',
      background: 'var(--breadcrumb-bg, rgba(255,255,255,0.03))',
      borderBottom: '1px solid var(--breadcrumb-border, rgba(255,255,255,0.07))',
      fontSize: '0.78rem',
      color: 'var(--breadcrumb-muted, #8898aa)',
      flexShrink: 0,
    }}>
      <Link
        to="/"
        style={{ color: 'var(--breadcrumb-link, #64748b)', display: 'flex', alignItems: 'center', textDecoration: 'none' }}
      >
        <FiHome size={13} />
      </Link>

      {group && (
        <>
          <FiChevronRight size={12} style={{ opacity: 0.5 }} />
          <span style={{ color: 'var(--breadcrumb-muted, #8898aa)' }}>{group}</span>
        </>
      )}

      <FiChevronRight size={12} style={{ opacity: 0.5 }} />
      <span style={{
        color: 'var(--breadcrumb-active, #cbd5e1)',
        fontWeight: 500,
      }}>{label}</span>
    </div>
  );
}
